import { SET_IS_EXPERT, IsExpertActionTypes } from '../actionTypes';

const setIsExpert = (isExpert?: boolean): IsExpertActionTypes => ({
  type: SET_IS_EXPERT,
  payload: isExpert,
});

export default setIsExpert;
